const SectionHeader = ({
  icon,
  tone,
  iconClass,
  title,
  action,
  className = "",
}) => (
  <div className={`ds-panel-header ${className}`}>
    <div className="section-heading">
      {icon && (
        <div
          className={`section-heading-icon ${
            iconClass || (tone ? `kpi-icon-${tone}` : "")
          }`}
        >
          {icon}
        </div>
      )}
      <h6 className="section-heading-text">{title}</h6>
    </div>
    {action}
  </div>
);

export default SectionHeader;
